import { TmrBaseResource } from 'stylewhere/api'

export class Places extends TmrBaseResource {
  static endpoint = '/api/v1/places' // /profile
}
